import { useContext, useEffect, useState } from "react";
import leo from "../img/home/leo.webp";
// import leo from "../img/home/leo.png";
import leo_mob from "../img/home/leo-mob.webp";
// import leo_mob from "../img/home/leo.png";
import { motion } from "framer-motion";
import { transition1 } from "../transitions";
import { CursorContext } from "../context/CursorContext";
import HeadingAnimation from "../components/HeadingAnimation";
import { ScrollLink } from "../components/ScrollLink";
import { BsArrowRight } from "react-icons/bs";

// ── Animated counter ──────────────────────────────────────────────────────────
const Counter = ({ to, suffix = "+" }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let current = 0;
    const step = Math.ceil(to / 40);
    const id = setInterval(() => {
      current += step;
      if (current >= to) {
        setCount(to);
        clearInterval(id);
      } else setCount(current);
    }, 35);
    return () => clearInterval(id);
  }, [to]);

  return (
    <>
      {count}
      {suffix}
    </>
  );
};

const stats = [
  { value: 5, suffix: "+", label: "Years Exp" },
  { value: 30, suffix: "+", label: "Projects" },
  { value: 2, suffix: "", label: "Companies" },
];

const Home = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);

  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={transition1}
      className="section overflow-hidden snap-start"
      id="home"
    >
      <div className="container mx-auto h-full relative">
        <div className="flex flex-col justify-center">
          <motion.div
            initial={{ opacity: 0, y: "-50%" }}
            whileInView={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: "-50%" }}
            transition={transition1}
            onMouseEnter={mouseEnterHandler} // 🧩 Trigger custom cursor on hover
            onMouseLeave={mouseLeaveHandler} // 🧩 Reset cursor on leave
            className="w-full pt-36 lg:pt-0 lg:pb-0 lg:w-auto z-10 lg:absolute flex flex-col justify-center items-center lg:items-start"
          >
            {/* 🧩 Name — sits above the jiggling title */}
            {/* <motion.p
              className="text-[18px] lg:text-[22px] font-secondary font-semibold tracking-wide text-slate-400 dark:text-slate-500 mb-1"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.15, duration: 0.5 }}
              viewport={{ once: false }}
            >
              Guru Leo
            </motion.p> */}

            {/* 🧩 Animated jiggling heading */}
            {/* <HeadingAnimation text={"GuruLeo"} noSplit={true} /> */}

            <HeadingAnimation text={"Software Developer"} />

            {/* 🧩 Subheading with location */}
            <p className="text-[26px] lg:text-[36px] font-secondary mb-4 lg:mb-8">
              Coimbatore, India
            </p>

            {/* 🧩 Stats row */}
            <motion.div
              className="flex gap-6 lg:gap-8 mb-6 lg:mb-10"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.35, duration: 0.5 }}
              viewport={{ once: false }}
            >
              {stats.map((stat, i) => (
                <div
                  key={i}
                  className="flex flex-col items-center lg:items-start"
                >
                  <span className="text-2xl lg:text-3xl font-bold font-primary">
                    <Counter to={stat.value} suffix={stat.suffix} />
                  </span>
                  <span className="text-[11px] uppercase tracking-widest text-slate-400 mt-0.5">
                    {stat.label}
                  </span>
                </div>
              ))}
            </motion.div>

            {/* 🧩 Hire Me button — untouched */}
            <ScrollLink section="contact" className="btn">
              Hire Me
              <span>
                <BsArrowRight />
              </span>
            </ScrollLink>
          </motion.div>

          {/* 🧩 Profile image */}
          <div className="flex justify-center lg:justify-end max-h-96 lg:max-h-max">
            <motion.div
              onMouseEnter={mouseEnterHandler}
              onMouseLeave={mouseLeaveHandler}
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              exit={{ scale: 0 }}
              transition={transition1}
              className="relative lg:-right-60 overflow-hidden"
            >
              <motion.img
                whileHover={{ scale: 1.1 }}
                transition={transition1}
                src={leo}
                className="lg-imge"
                alt=""
              />
              <motion.img
                whileHover={{ scale: 1.1 }}
                transition={transition1}
                src={leo_mob}
                className="mob-imge"
                alt=""
              />
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Home;
